<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Button from "@smui/button";
  import Spinner from "./Spinner.svelte";

  import { setToken, isLoggedIn, clearToken } from "./auth";
  import { apiGet, apiPost, notify } from "./httpCommon";
  import { Textfield } from "./components";
  import Paper, { Title, Content } from "@smui/paper";

  export let verification_code;

  let data = { };
  let errors = {};
  let submitting = false;

  async function submit() {
    if (!submitting) {
      errors = {};

      if (!data.password || data.password !== data.password_confirm) {
        errors.password = "Passwords must match";
      }

      console.log("errors: ", errors);

      if (Object.keys(errors).length === 0) {
        submitting = true;
        try {
          const json = await apiPost(`/password-reset/${verification_code}`, data);
          if (json && json.token) {
            setToken(json.token);
          }
        } catch (error) {
          errors = error.errors;
        } finally {
          submitting = false;
        }
        if (isLoggedIn()) {
          navigate("/");
        }
      }
    }
  }

  async function getUsername() {
    const {username, email} = await apiGet("/get-username", verification_code);
    data.username = username || email;
  }

  onMount(() => {
    getUsername();
    clearToken();
  });
</script>

<style>
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }

  .login-container {
    width: 300px;
    text-align: center;
    padding: 24px;
  }

  .action-container {
    margin-top: 32px;
  }
</style>

<main class="container">
  <Paper elevation={5}>
    <Title class="centre">Fooddisco - Password Reset</Title>
    <Content>
      <div class="login-container">
        <form on:submit|preventDefault={submit}>
          <Textfield
            class="stretch"
            variant="outlined"
            label="Choose Username"
            bind:value={data.username}
            error={errors.username} />
          <Textfield
            class="stretch"
            variant="outlined"
            type="password"
            label="Password"
            bind:value={data.password}
            error={errors.password} />
          <Textfield
            class="stretch"
            variant="outlined"
            type="password"
            label="Confirm password"
            bind:value={data.password_confirm}
            error={errors.password} />
          <div class="action-container">
            <Button type="submit" variant="raised" disabled={submitting}>
              {#if submitting}
                <Spinner />
              {:else}Save{/if}
            </Button>
          </div>
        </form>
      </div>
    </Content>
  </Paper>
</main>
